import request from 'iebdc/utils/request';
import { REST_SERVICE } from 'iebdc/config';

// 添加代理人
export const addAgent = (params) =>
  request({
    url: REST_SERVICE.jbr.addDigitalAgent,
    method: 'post',
    data: params
  });
// 查找代理人列表
export const getAgentsByUserId = (params) =>
  request({
    url: REST_SERVICE.jbr.getDigitalAgentList,
    method: 'post',
    params
  });
// 修改代理人
export const updateAgent = (params) =>
  request({
    url: REST_SERVICE.jbr.updateDigitalAgent,
    method: 'post',
    data: params
  });

// 删除代理人 启动或者禁用政务网上经办人
export const deleteAgent = (params) =>
  request({
    url: REST_SERVICE.jbr.deleteDigitalAgent,
    method: 'post',
    data: params
  });

// 获取经办人角色
export const getDigitalAgentRole = (params) =>
  request({
    url: REST_SERVICE.jbr.getDigitalAgentRole,
    method: 'get',
    params
  });

//经办人查询列表接口
export const instUserfindUser = (params) =>
  request({
    url: REST_SERVICE.jbr.instUserfindUser,
    method: 'get',
    params
  });

//根据企业id获取企业的经办人信息
export const getAgentUserByQyId = (params) =>
  request({
    url: REST_SERVICE.jbr.getAgentUserByQyId,
    method: 'post',
    data: params
  });

//根据当前登录的姓名和证件号获取办人列表信息
export const getAgentUserList = (params) =>
  request({
    url: REST_SERVICE.jbr.getAgentUserList,
    method: 'post',
    data: params
  });

//选择对应的经办人企业信息
export const getAgentUserQyUser = (params) =>
  request({
    url: REST_SERVICE.jbr.getAgentUserQyUser,
    method: 'post',
    data: params
  });
